<div class="poe-scroll">
  <div class="readonlytbox poe-submission">
    <div class="edittablebdr m-0">
      <div class="ui-g">
        <div class="ui-g-8 msgbox-8">
          @for (message of msgsPoeStatus; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
        </div>
        <div class="ui-g-4"></div>
        <div class="ui-g-8 ui-md-8 ui-lg-8">
          <div class="hdbl">POE Status</div>
        </div>
        <div class="ui-g-1"></div>
        <div class="ui-g-2 poe-btns-wrapper">
          @if (btnPoeStatus) {
            <div>
              <button
                type="submit"
                pButton
                (click)="onSubmitPoeStatus()"
                class="flat btnmr fl-rt">
                Save
              </button>
              <button
                type="button"
                pButton
                (click)="editPoeStatusCancel()"
                class="ui-button-secondary flat fl-rt">
                Cancel
              </button>
            </div>
          }
        </div>
        <div class="ui-g-1 editResetIcon">
          <a
            pTooltip="Reset"
            (click)="resetPoeInfo()"
            (keydown.enter)="resetPoeInfo()"
            tabindex="0"
            ><span class="fa fa-repeat"></span
          ></a>
          <a
            pTooltip="Edit"
            (click)="editPoeStatus()"
            (keydown.enter)="editPoeStatus()"
            tabindex="0"
            tooltipPosition="bottom"
            ><span class="fa fa-pencil ico cpointer fl-rt"></span
          ></a>
        </div>
      </div>

      <form [formGroup]="formPOEStatus">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <th style="width: 25%">POE Status</th>
            <th style="width: 18%">POE Document Submitted Date</th>
            <th style="width: 18%">POE Completion Date</th>
            <th style="width: 39%"></th>
          </tr>
          <tr>
            <td>
              <p-select
                appendTo="body"
                [options]="eventPOEStatus"
                [readonly]="isReadonlyPOEStatus"
                [class.readonlydd]="isReadonlyPOEStatus === true"
                [disabled]="isPOEDocumentEditMode === false"
                formControlName="poeStatus"
                [placeholder]="eventPOEInfo?.eventPoeStatusName || '--SELECT--'"
                optionValue="eventPOEStatusId"
                optionLabel="name"></p-select>
            </td>
            <td>
              <p-datepicker
                appendTo="body"
                [readonlyInput]="true"
                formControlName="poeDocumentSubmittedDate"
                dateFormat="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOEStatus === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOEStatus === true"
                [defaultDate]="maxYearDate">
              </p-datepicker>
            </td>
            <td>
              <p-datepicker
                appendTo="body"
                [readonlyInput]="true"
                formControlName="poeCompletionDate"
                dateFormat="mm/dd/yy"
                [readonlyInput]="true"
                [showOnFocus]="false"
                [showIcon]="isReadonlyPOEStatus === false"
                [iconDisplay]="'input'"
                [class.readonlycaltb]="isReadonlyPOEStatus === true"
                [defaultDate]="maxYearDate"></p-datepicker>
            </td>
            <td></td>
          </tr>
        </table>
      </form>
    </div>

    <div class="edittablebdr m-0">
      <div class="ui-g customer_validation">
        <div class="readonlytbox">
          @if (surveyDetails && surveyDetails.hasCustomerSurvey) {
            <div>
              @if (!isMRPPProgram || isCustomerSectionEnabled()) {
                <div class="edittablebdr">
                  <div class="ui-g">
                    <div class="ui-g-9 ui-md-9 ui-lg-9">
                      <div class="hdbl">Customer Validation</div>
                    </div>
                    <div class="ui-g-2 poe-btns-wrapper">
                      @if (btnNavCustValidation) {
                        <div>
                          <button
                            type="submit"
                            pButton
                            (click)="onSubmitCustomerValidation()"
                            class="flat btnmr fl-rt">
                            Save
                          </button>
                          <button
                            type="button"
                            pButton
                            (click)="editCustomerValidationCancel()"
                            class="ui-button-secondary flat fl-rt">
                            Cancel
                          </button>
                        </div>
                      }
                    </div>
                    <div class="ui-g-1 editResetIcon">
                      <a
                        (click)="resetCustomerValidation()"
                        (keydown.enter)="resetCustomerValidation()"
                        tabindex="0"
                        pTooltip="Reset"
                        ><span class="fa fa-repeat"></span
                      ></a>
                      <a
                        pTooltip="Edit"
                        (click)="editCustomerValidation()"
                        (keydown.enter)="editCustomerValidation()"
                        tabindex="0"
                        tooltipPosition="bottom">
                        <span class="fa fa-pencil ico cpointer fl-rt"></span>
                      </a>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-5 msgbox-5">
                      @for (message of msgsCustValidation; track message) {
                        <p-message
                          [life]="3000"
                          [text]="message.detail"></p-message>
                      }
                    </div>
                  </div>
                  <p-table
                    [value]="eventCustomerValidations"
                    [paginator]="true"
                    [rows]="5"
                    [alwaysShowPaginator]="false">
                    <ng-template #header let-columns>
                      <tr>
                        <th style="width: 20%">Customer Name</th>
                        <th style="width: 10%">Customer Country</th>
                        <th style="width: 10%">Validation Type</th>
                        <th style="width: 10%">Validation Details</th>
                        @if (isSubscriptionVisible()) {
                          <th style="width: 18%">Subscription ID</th>
                        }
                        <th style="width: 20%">Customer Validation Status</th>
                        <th style="width: 22%">Reason</th>
                        <th style="width: 18%">Preview</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-rowData>
                      <tr
                        class="customer-val-row"
                        [ngClass]="{
                          'selected-customer':
                            customerId === rowData.eventCustomerId
                        }"
                        (click)="
                          ShowSelectedCustomerSurveyList(
                            rowData.eventCustomerId,
                            rowData.customerName
                          )
                        ">
                        <td>{{ rowData.customerName }}</td>
                        <td>{{ rowData.customerCountry }}</td>
                        <td>{{ rowData.eventCustomerValidationType }}</td>
                        <td>{{ rowData.eventCustomerValidationDetail }}</td>
                        @if (isSubscriptionVisible()) {
                          <td>
                            {{ rowData.subscriptionId }}
                          </td>
                        }
                        <td>
                          <p-select
                            appendTo="body"
                            [options]="validationStatuses"
                            [placeholder]="
                              (rowData.selectedValidationStatus &&
                                rowData.selectedValidationStatus.name) ||
                              '--SELECT--'
                            "
                            optionLabel="name"
                            (onChange)="onChangeValidationStatus(rowData)"
                            [(ngModel)]="rowData.selectedValidationStatus"
                            [class.readonlydd]="
                              isReadonlyCustomerValidation || isDisabledEdit()
                            "
                            [readonly]="
                              isReadonlyCustomerValidation || isDisabledEdit()
                            "
                            [disabled]="
                              isReadonlyCustomerValidation || isDisabledEdit()
                            ">
                          </p-select>
                        </td>
                        <td>
                          @if (rowData.isValidationRejectionVisible) {
                            <p-select
                              appendTo="body"
                              [options]="rejectionReasons"
                              [placeholder]="
                                rowData.eventCustomerRejectionReason ||
                                '--SELECT--'
                              "
                              optionLabel="rejectReasonDescription"
                              (onChange)="onChangeRejectionReason(rowData)"
                              [(ngModel)]="rowData.selectedRejectionReason"
                              [class.readonlydd]="
                                isReadonlyCustomerValidation || isDisabledEdit()
                              "
                              [readonly]="
                                isReadonlyCustomerValidation || isDisabledEdit()
                              "
                              [disabled]="
                                isReadonlyCustomerValidation || isDisabledEdit()
                              "
                              [style]="{ width: '60%' }">
                            </p-select>
                          }
                        </td>
                        <td>
                          <a
                            class="ml-2"
                            (click)="showCustomerValidationPreview(rowData)"
                            (keydown.enter)="
                              showCustomerValidationPreview(rowData)
                            "
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i>
                          </a>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }

              @if (!isMRPPProgram || isCustomerSectionEnabled()) {
                <div class="edittablebdr">
                  <div class="ui-g customer-survey-wrapper">
                    <div class="ui-g-9 ui-md-9 ui-lg-9">
                      <div class="hdbl">{{ customerName }} Survey</div>
                    </div>
                    <div class="ui-g-2 poe-btns-wrapper">
                      @if (btnCustomerSurvey) {
                        <div>
                          <button
                            type="submit"
                            pButton
                            [disabled]="disableCustSurveySave"
                            (click)="updateCustomerSurvey()"
                            class="flat btnmr fl-rt">
                            Save
                          </button>
                          <button
                            type="button"
                            pButton
                            (click)="editCustomerSurveyCancel()"
                            class="ui-button-secondary flat fl-rt">
                            Cancel
                          </button>
                        </div>
                      }
                    </div>
                    <div class="ui-g-1 editResetIcon">
                      <a
                        (click)="resetCustomerSurvey()"
                        (keydown.enter)="resetCustomerSurvey()"
                        tabindex="0"
                        pTooltip="Reset"
                        ><span class="fa fa-repeat"></span
                      ></a>
                      <a
                        pTooltip="Edit"
                        (click)="editCustomerSurvey()"
                        (keydown.enter)="editCustomerSurvey()"
                        tabindex="0"
                        tooltipPosition="bottom">
                        <span class="fa fa-pencil ico cpointer fl-rt"></span>
                      </a>
                    </div>
                  </div>
                  <div class="ui-g customer-survey-wrapper">
                    <div class="ui-g-5 msgbox-5">
                      @for (message of msgsCustSurvey; track message) {
                        <p-message
                          [life]="3000"
                          [text]="message.detail"></p-message>
                      }
                    </div>
                  </div>

                  <p-table [value]="eventCustomerSurveys">
                    <ng-template #header let-columns>
                      <tr style="border-bottom: 1pt solid rgba(0, 0, 0, 0.1)">
                        <th style="width: 6%"></th>
                        <th style="width: 15%">Survey Name</th>
                        <th style="width: 10%">Survey Date</th>
                        <th style="width: 15%">Status</th>
                        <th style="width: 27%">Reason</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-rowData>
                      <tr style="border-bottom: 0px solid rgba(0, 0, 0, 0.1)">
                        <td>
                          <a
                            class="cpointer"
                            (keydown.enter)="
                              cusSurveyResponse(rowData.surveyGUID)
                            "
                            tabindex="0"
                            (click)="cusSurveyResponse(rowData.surveyGUID)"
                            >+ Response</a
                          >
                        </td>
                        <td>{{ rowData.surveyName }}</td>
                        <td>
                          {{ rowData.submittedDate | date: 'MM/dd/yyyy' }}
                        </td>
                        <td>
                          @if (eventCustomerSurveyStatus) {
                            <p-select
                              appendTo="body"
                              [options]="eventCustomerSurveyStatus"
                              (onChange)="
                                onChangeCustomerSurveySelectedStatus(rowData)
                              "
                              [readonly]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [class.readonlydd]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [disabled]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [placeholder]="
                                rowData.selectedStatus.name || '--SELECT--'
                              "
                              optionLabel="name"
                              [(ngModel)]="rowData.selectedStatus">
                            </p-select>
                          }
                        </td>
                        <td>
                          @if (rowData['isRejectedStatusSelected']) {
                            <p-select
                              appendTo="body"
                              (onChange)="
                                onChangeCustomerSurveySelectedReason(rowData)
                              "
                              [options]="eventCustomerSurveyRejectReasons"
                              [readonly]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [class.readonlydd]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [disabled]="
                                isReadonlyCustomerSurvey ||
                                isSurveyEditDisabled(rowData)
                              "
                              [placeholder]="
                                rowData.rejectionReasons[0].name || '--SELECT--'
                              "
                              optionLabel="rejectReasonDescription"
                              [(ngModel)]="rowData.rejectionReasons[0]"
                              [style]="{ width: '71%' }"></p-select>
                          }
                        </td>
                      </tr>

                      @if (rowData.surveyGUID === CusSurveyGUID) {
                        <tr>
                          <td class="bgtd">
                            <table
                              class="reptable"
                              cellpadding="0"
                              cellspacing="0"
                              style="width: 1050px">
                              <tr>
                                <th style="width: 55px">Ques#</th>
                                <th>Questions</th>
                                <th>Response</th>
                              </tr>
                              @if (isSurveyResponseload) {
                                <tr>
                                  <td colspan="3">
                                    <div class="btnloader"></div>
                                  </td>
                                </tr>
                              }
                              @if (!isSurveyResponseload) {
                                <ng-template
                                  ngFor
                                  let-response
                                  [ngForOf]="rowData.responses">
                                  <tr>
                                    <td>
                                      {{ response.questionSequenceOrder }}
                                    </td>
                                    <td>{{ response.question }}</td>
                                    <td>{{ response.answer }}</td>
                                  </tr>
                                </ng-template>
                              }
                            </table>
                          </td>
                        </tr>
                      }
                    </ng-template>
                  </p-table>
                </div>
              }

              @if (checkIfCustomerSurveyNotOnetoMany()) {
                <div class="edittablebdr">
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="ui-g-9 ui-md-9 ui-lg-9">
                        <div class="hdbl">Summary</div>
                      </div>
                      <div class="ui-g-2 poe-btns-wrapper">
                        @if (btnCustomerSurvey) {
                          <div>
                            <button
                              type="submit"
                              pButton
                              [disabled]="disableCustSurveySave"
                              (click)="updateCustomerSurvey()"
                              class="flat btnmr fl-rt">
                              Save
                            </button>
                            <button
                              type="button"
                              pButton
                              (click)="editCustomerSurveyCancel()"
                              class="ui-button-secondary flat fl-rt">
                              Cancel
                            </button>
                          </div>
                        }
                      </div>
                      <div class="ui-g-1 editResetIcon">
                        <a
                          (click)="resetCustomerSurvey()"
                          (keydown.enter)="resetCustomerSurvey()"
                          tabindex="0"
                          pTooltip="Reset"
                          ><span class="fa fa-repeat"></span
                        ></a>
                        <a
                          pTooltip="Edit"
                          (click)="editCustomerSurvey()"
                          (keydown.enter)="editCustomerSurvey()"
                          tabindex="0"
                          tooltipPosition="bottom">
                          <span class="fa fa-pencil ico cpointer fl-rt"></span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <p-table [value]="eventCustomerSurveys">
                    <ng-template #header let-columns>
                      <tr style="border-bottom: 1pt solid rgba(0, 0, 0, 0.1)">
                        <th style="width: 6%"></th>
                        <th style="width: 15%">Survey Name</th>
                        <th style="width: 10%">Survey Date</th>
                        <th style="width: 15%">Status</th>
                        <th style="width: 27%">Reason</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-survey>
                      <tr style="border-bottom: 0px solid rgba(0, 0, 0, 0.1)">
                        <td>
                          <a
                            class="cpointer"
                            (keydown.enter)="
                              cusSurveyResponse(survey.surveyGUID)
                            "
                            tabindex="0"
                            (click)="cusSurveyResponse(survey.surveyGUID)"
                            >+ Response</a
                          >
                        </td>
                        <td>{{ survey.surveyName }}</td>
                        <td>{{ survey.submittedDate | date: 'MM/dd/yyyy' }}</td>
                        <td>
                          <p-select
                            appendTo="body"
                            [options]="eventCustomerSurveyStatus"
                            (onChange)="
                              onChangeCustomerSurveySelectedStatus(survey)
                            "
                            [readonly]="isReadonlyCustomerSurvey"
                            [class.readonlydd]="
                              isReadonlyCustomerSurvey === true
                            "
                            [disabled]="isReadonlyCustomerSurvey === true"
                            [placeholder]="
                              survey.selectedStatus.name || '--SELECT--'
                            "
                            optionLabel="name"
                            optionValue="eventSurveyStatusId"
                            [(ngModel)]="survey.selectedStatus">
                          </p-select>
                        </td>
                        <td>
                          @if (
                            survey['isRejectedStatusSelected'] &&
                            !isReadonlyCustomerSurvey
                          ) {
                            <p-multiSelect
                              [placeholder]="
                                survey.rejectionReasons.name || '--SELECT--'
                              "
                              (onChange)="
                                onChangeCustomerSurveySelectedReason(survey)
                              "
                              [maxSelectedLabels]="2"
                              [options]="eventCustomerSurveyRejectReasons"
                              optionLabel="rejectReasonDescription"
                              [style]="{ width: '71%' }"
                              [(ngModel)]="
                                survey.rejectionReasons
                              "></p-multiSelect>
                          }
                          @if (
                            survey.rejectionReasons && isReadonlyCustomerSurvey
                          ) {
                            <span>{{
                              getSurveyReasons(survey.rejectionReasons)
                            }}</span>
                          }
                        </td>
                      </tr>

                      @if (survey.surveyGUID === CusSurveyGUID) {
                        <tr>
                          <td class="bgtd">
                            <table
                              class="reptable"
                              cellpadding="0"
                              cellspacing="0"
                              style="width: 1050px">
                              <tr>
                                <th style="width: 55px">Ques#</th>
                                <th>Questions</th>
                                <th>Response</th>
                              </tr>
                              @if (isSurveyResponseload) {
                                <tr>
                                  <td colspan="3">
                                    <div class="btnloader"></div>
                                  </td>
                                </tr>
                              }
                              @if (!isSurveyResponseload) {
                                <ng-template
                                  ngFor
                                  let-response
                                  [ngForOf]="survey.responses">
                                  <tr>
                                    <td>
                                      {{ response.questionSequenceOrder }}
                                    </td>
                                    <td>{{ response.question }}</td>
                                    <td>{{ response.answer }}</td>
                                  </tr>
                                </ng-template>
                              }
                            </table>
                          </td>
                        </tr>
                      }
                    </ng-template>
                  </p-table>
                </div>
              }
            </div>
          }

          <div class="edittablebdr" [ngClass]="{ 'mgn-top': isMRPPProgram }">
            <div class="ui-g">
              <div class="ui-g-4 ui-md-4 ui-lg-4">
                <div class="hdbl">
                  {{
                    this.programSharedService.checkEventType(
                      EventType.TeamsRoomsOneToMany
                    )
                      ? 'POE Documentation'
                      : 'Required Documentation'
                  }}
                </div>
              </div>
              <div class="ui-g-6 poe-btns-wrapper">
                <div [ngClass]="{ 'pdn-rgt': isPOEDocumentEditMode }">
                  <ng-container *ngFor="let config of buttonConfig">
                    @if (
                      programSharedService.checkEventType(config.eventType)
                    ) {
                      <button
                        type="button"
                        pButton
                        (click)="onPoeDocumentUploadClick(config.documentType)"
                        pTooltip="Upload or View"
                        tooltipPosition="top"
                        class="ui-button-info btnpad btnmr">
                        {{ config.label }}
                      </button>
                    }
                  </ng-container>
                </div>
                @if (isPOEDocumentEditMode) {
                  <div>
                    <button
                      type="submit"
                      pButton
                      [disabled]="disableRequiredDocSave"
                      (click)="updateDocument()"
                      class="flat btnmr fl-rt">
                      Save
                    </button>
                    <button
                      type="button"
                      pButton
                      (click)="cancelDocument()"
                      class="ui-button-secondary flat fl-rt">
                      Cancel
                    </button>
                  </div>
                }
              </div>

              <div class="ui-g-2 editResetIcon">
                <a
                  (click)="resetDocument()"
                  pTooltip="Reset"
                  (keydown.enter)="resetDocument()"
                  tabindex="0"
                  ><span class="fa fa-repeat"></span
                ></a>
                <a
                  pTooltip="Edit"
                  (click)="editDocument()"
                  (keydown.enter)="editDocument()"
                  tabindex="0"
                  tooltipPosition="bottom">
                  <span class="fa fa-pencil ico cpointer fl-rt"></span>
                </a>
              </div>
            </div>
            <div class="ui-g">
              <div class="ui-g-5 msgbox-5">
                @for (message of msgsEventDocumentsStatus; track message) {
                  <p-message [life]="3000" [text]="message.detail"></p-message>
                }
              </div>
            </div>

            <div class="ui-g">
              @if (documents) {
                <p-table [value]="documents">
                  <ng-template #header>
                    <tr>
                      <th style="width: 20%">Document Name</th>
                      <th style="width: 10%">Download</th>
                      <th style="width: 10%">Preview</th>
                      <th style="width: 15%">Upload Date</th>
                      <th style="width: 15%">Type</th>
                      <th style="width: 20%">Status</th>
                      <th style="width: 30%">Reason</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>
                        @if (rowData.filePath) {
                          <a target="_blank" href="{{ rowData.filePath }}">{{
                            rowData.documentName
                          }}</a>
                        } @else {
                          {{ rowData.documentName }}
                        }
                      </td>
                      <td>
                        @if (rowData.filePath) {
                          <span
                            class="fa fa-download ico cpointer"
                            pTooltip="Download"
                            (keydown.enter)="downloadPOE(rowData)"
                            tabindex="0"
                            (click)="downloadPOE(rowData)"
                            tooltipPosition="bottom"></span>
                        }
                      </td>
                      <td>
                        @if (rowData.filePath) {
                          <a
                            class="ml-2"
                            (click)="previewPoeDocument(rowData, false)"
                            (keydown.enter)="previewPoeDocument(rowData, false)"
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i>
                          </a>
                        }
                      </td>
                      <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
                      <td>{{ getPoeDocumentType(rowData.documentType) }}</td>
                      <td>
                        <p-select
                          appendTo="body"
                          [options]="eventDocumentStatus"
                          [placeholder]="
                            rowData.selectedDocumentStatus.name || '--SELECT--'
                          "
                          optionLabel="name"
                          optionValue="eventDocumentStatusId"
                          (onChange)="onChangeDocStatus(rowData)"
                          [(ngModel)]="rowData.selectedDocumentStatus"
                          [class.readonlydd]="isPOEDocumentEditMode === false"
                          [disabled]="isPOEDocumentEditMode === false"
                          [readonly]="!isPOEDocumentEditMode"></p-select>
                      </td>
                      <td>
                        @if (
                          rowData.isDocStatusRejectionVisible === true &&
                          isPOEDocumentEditMode
                        ) {
                          <p-multiSelect
                            [options]="
                              rowData.selectableEventDocumentRejectionReasons
                            "
                            [(ngModel)]="
                              rowData.selectedDocumentRejectionReasons
                            "
                            [placeholder]="
                              rowData.selectedDocumentRejectionReasons.name ||
                              '--SELECT--'
                            "
                            [readonly]="!isPOEDocumentEditMode"
                            optionLabel="rejectReasonDescription"
                            optionValue="eventDocumentRejectionReasonId"
                            (onChange)="onChangeRejectionReason(rowData)"
                            [maxSelectedLabels]="1">
                          </p-multiSelect>
                        }
                        @if (
                          !isPOEDocumentEditMode &&
                          rowData.selectedDocumentRejectionReasons
                        ) {
                          <span>{{
                            getReasons(rowData.selectedDocumentRejectionReasons)
                          }}</span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              }
            </div>

            <div class="edittablebdr m-0">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-12 ui-lg-12">
                  <div class="hdbl mt-2">Saved Documents</div>
                </div>

                <p-table
                  [value]="documentHistories"
                  [paginator]="true"
                  [rows]="3"
                  [showCurrentPageReport]="true">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="width: 25%">Document Name</th>
                      <th style="width: 15%">Preview</th>
                      <th style="width: 15%">Upload Date</th>
                      <th style="width: 15%">Type</th>
                      <th style="width: 15%">Status</th>
                      <th style="width: 35%">Reason</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>
                        @if (rowData.filePath) {
                          <a
                            target="_blank"
                            href="{{ rowData.filePath }}"
                            class="saved-poe-file"
                            >{{ rowData.fileName }}</a
                          >
                        } @else {
                          {{ rowData.fileName }}
                        }
                      </td>
                      <td>
                        @if (rowData.filePath) {
                          <a
                            class="ml-2"
                            (click)="previewPoeDocument(rowData, true)"
                            (keydown.enter)="previewPoeDocument(rowData, true)"
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i>
                          </a>
                        }
                      </td>
                      <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
                      <td>{{ getPoeDocumentType(rowData.documentType) }}</td>
                      <td>{{ rowData.documentStatus }}</td>
                      <td>
                        {{ getReasons(rowData.eventDocumentRejectionReason) }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

              @if (canShowEventPreviewModel && !isMRPPProgram) {
                <app-event-preview
                  [eventPreviewInput]="eventPreviewInput"
                  (closePreviewModal)="closePreview()"></app-event-preview>
              }

              @if (canShowEventPreviewModel && isMRPPProgram) {
                <app-mrpp-preview
                  [mrppPreviewInput]="mrppPreviewInput"
                  (closePreviewModal)="closePreview()"></app-mrpp-preview>
              }

              @if (canShowCustomerValidationPreviewModel) {
                <app-customer-validation-preview
                  [customerValidationPreviewInput]="
                    customerValidationPreviewInput
                  "
                  (closePreviewModal)="
                    closeCustomerValidationPreview()
                  "></app-customer-validation-preview>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="loadUploadDialog"
  class="dg-model"
  [contentStyle]="{
    'max-height': '550px',
    'overflow-y': 'auto',
    width: '800px',
    'z-index': '10027px'
  }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [focusOnShow]="false">
  <ng-template #header>
    <div class="ui-g-11 dg-title">
      {{ fileUploadHeader }}
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav dg-close"
      (click)="cancelUploadDocument()"
      tabindex="0"
      (keydown.enter)="cancelUploadDocument()">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>

  <div class="tolFile">
    <p>
      File size must be less than 10 MB.
      <span>Acceptable file types: doc, pdf, image or pptx</span>
    </p>
  </div>
  <div class="tolFile">
    <p><b>Note: </b>Drag and Drop/Browse files will be Uploaded to Server.</p>
  </div>
  @for (message of umsgs; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
  <div
    class="uploadfilecontainer"
    appDragDrop
    (onFileDropped)="uploadFile($any($event))">
    <div><i class="fa fa-cloud-upload fa-lg"></i></div>
    Drag and drop files here or
    <a
      (click)="fileInputUpload.click()"
      (keydown.enter)="fileInputUpload.click()"
      tabindex="0"
      >Browse</a
    >
    <input
      hidden
      type="file"
      #fileInputUpload
      (change)="uploadFile($any($event.target).files)" />
  </div>
  @if (filesUpload) {
    <div class="tolFile">
      <p>
        Total Number of File in Uploading:
        {{ filesUpload.length }}
      </p>
    </div>
  }
  <div class="files-list listtable">
    <table>
      <tr *ngFor="let file of filesUpload; let i = index">
        <td>{{ file.fileName }}</td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <i class="fa fa-check-circle"></i>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <span>{{ formatBytes(file?.size, 0) }}</span>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
      </tr>
    </table>
  </div>
  <br />
  <div style="text-align: right">
    <button
      type="submit"
      pButton
      [ngClass]="{
        'active-button': isButtonActive,
        'inactive-button': !isButtonActive
      }"
      (click)="submitFile()"
      class="flat btnmr"
      [disabled]="!isButtonActive">
      Submit
    </button>
    <button
      type="button"
      pButton
      (click)="cancelUploadDocument()"
      class="ui-button-secondary flat">
      Cancel
    </button>
  </div>
</p-dialog>
